import { render, staticRenderFns } from "./vfg-vsswitch.vue?vue&type=template&id=0f52909e"
import script from "./vfg-vsswitch.vue?vue&type=script&lang=js"
export * from "./vfg-vsswitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports